import { createSelector, createSlice } from "@reduxjs/toolkit"
import { filterService } from "../../services/book/filter"
import {
  getCountriesFromTerminals,
  getExcludedTerminals,
  getIncludedTerminals,
} from "../../../packs/travel_book/avia_v3/utils/filters/serch"
import { filtersService } from "../../services/book/filters"
import { CURRENCIES } from "../../../variables/common"
import {
  DATES_FIX_MODE,
  DATES_FLEX_MODE,
  TOURS_ROUNDTRIP,
} from "../../../packs/travel_book/avia_v3/utils/variables/search"
import { companiesService } from "../../services/transport/companies"

const initialState = {
  dates: {
    from: [],
    to: [],
    round_trip: false,
    one_way: true,
    fligthDates: null,
    availableDepart: [],
    availableRetur: [],
    mode: DATES_FLEX_MODE,
  },
  terminals: {
    departureTerminals: [],
    arrivalTerminals: [],
    defaultDeparture: null,
    defaultArrival: null,
    isLocal: true,
    isSwap: false,
  },
  currency: CURRENCIES[0].code,
  // tourse: TOURS_ROUNDTRIP?.prices,
  tourse: [],
  user: null,
  passengers: {
    children: 0,
    adults: 1,
    infants: 0,
  },
  users: [],
  countries: [],
  companies: [],
  airline_codes: [],
}

const aviaSearchSlice = createSlice({
  name: "aviaSearch",
  initialState,
  reducers: {
    setAviaSearchParams: (state, action) => {
      const { key, value } = action.payload
      const keys = key.split(".")
      let current = state

      keys.forEach((k, index) => {
        if (index === keys.length - 1) {
          current[k] = value
        } else {
          if (!current[k]) current[k] = {}
          current = current[k]
        }
      })
    },
    selectAviaTerminalById: (state, action) => {
      const { terminalId, type } = action.payload
      const terminalsKey = type === "departure" ? "departureTerminals" : "arrivalTerminals"

      let targetTerminal = null
      let targetCountry = null

      state.terminals[terminalsKey].forEach((countryObj) => {
        countryObj.terminals.forEach((terminal) => {
          if (terminal.id === terminalId) {
            targetTerminal = terminal
            targetCountry = countryObj
          }
        })
      })

      if (!targetTerminal) return

      if (targetTerminal.is_selected) {
        targetTerminal.is_selected = false

        const hasSelectedTerminals = targetCountry.terminals.some((t) => t.is_selected)
        if (!hasSelectedTerminals) {
          targetCountry.is_selected = false
        }

        if (type === "departure") {
          const remainingSelected = state.terminals[terminalsKey]
            .flatMap((c) => c.terminals)
            .filter((t) => t.is_selected)

          if (remainingSelected.length > 0) {
            state.terminals.isLocal = remainingSelected.some((t) => t.is_local)
          }
        }

        return
      }

      let selectedCount = 0
      state.terminals[terminalsKey].forEach((countryObj) => {
        countryObj.terminals.forEach((terminal) => {
          if (terminal.is_selected) selectedCount++
        })
      })

      if (selectedCount < 3) {
        targetTerminal.is_selected = true
        targetCountry.is_selected = true

        if (type === "departure") {
          const allSelected = state.terminals[terminalsKey]
            .flatMap((c) => c.terminals)
            .filter((t) => t.is_selected)

          state.terminals.isLocal = allSelected.some((t) => t.is_local)
        }
      }
    },

    setSelectedAviaTerminals: (state, action) => {
      const { departureIds = [], arrivalIds = [] } = action.payload
      const sync = (terminalsKey, ids) => {
        state.terminals[terminalsKey].forEach((countryObj) => {
          countryObj.terminals.forEach((terminal) => {
            terminal.is_selected = ids.includes(terminal.id)
          })
        })
      }
      sync("departureTerminals", departureIds)
      sync("arrivalTerminals", arrivalIds)

      const selectedDepartureTerminals = state.terminals.departureTerminals
        .flatMap((c) => c.terminals)
        .filter((t) => t.is_selected)

      state.terminals.isLocal = selectedDepartureTerminals.some((t) => t.is_local)
    },

    selectAviaCountryById: (state, action) => {
      const { code, type = "arrival" } = action.payload
      const terminalsKey = type === "departure" ? "departureTerminals" : "arrivalTerminals"

      const country = state.terminals[terminalsKey].find((c) => c.country_code === code)

      if (!country) return

      // переключаем страну
      country.is_selected = !country.is_selected

      // сбрасываем ВСЕ терминалы этой страны
      country.terminals.forEach((terminal) => {
        terminal.is_selected = false
      })
    },
    toggleSelectAllAviaCountries: (state, action) => {
      const { type = "arrival", protectedCountries = [] } = action.payload

      const terminalsKey = type === "departure" ? "departureTerminals" : "arrivalTerminals"

      const countries = state.terminals[terminalsKey]

      const allSelected = countries.every(
        (country) => country.is_selected || protectedCountries.includes(country.country_code)
      )

      countries.forEach((country) => {
        if (protectedCountries.includes(country.country_code)) {
          country.is_selected = true
        } else {
          country.is_selected = !allSelected
        }
      })
    },
    resetAllExceptProtectedTerminals: (state, action) => {
      const { type = "arrival", protectedTerminals = [] } = action.payload
      const terminalsKey = type === "departure" ? "departureTerminals" : "arrivalTerminals"

      state.terminals[terminalsKey].forEach((countryObj) => {
        countryObj.terminals.forEach((terminal) => {
          const isProtected = protectedTerminals.includes(terminal.id)
          if (!isProtected) {
            terminal.is_selected = false
          }
        })
      })
    },
    resetAviaCountriesExceptProtected: (state, action) => {
      const { type = "departure", protectedCountries = [] } = action.payload

      const terminalsKey = type === "departure" ? "departureTerminals" : "arrivalTerminals"

      const countries = state.terminals[terminalsKey]

      countries.forEach((country) => {
        country.is_selected = protectedCountries.includes(country.country_code)
      })
    },
    swapAviaTerminals: (state) => {
      const tempTerminals = state.terminals.departureTerminals
      const tempDefault = state.terminals.defaultDeparture


      console.log('------')

      state.terminals.departureTerminals = state.terminals.arrivalTerminals
      state.terminals.arrivalTerminals = tempTerminals

      state.terminals.defaultDeparture = state.terminals.defaultArrival
      state.terminals.defaultArrival = tempDefault
      // state.terminals.isLocal = !state.terminals.isLocal

      // state.terminals.isSwap = !state.terminals.isSwap

      state.terminals.isSwap = !state.terminals.isSwap
      // state.terminals.isLocal = !state.terminals.isLocal
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      filterService.endpoints.getAviaFilterData.matchFulfilled,
      (state, action) => {
        const { dates, terminals, default_departure, default_arrival, list_users, settings } =
          action.payload

        const { is_empty_terminals = false } = settings

        state.dates.from = [dates.from] ?? []
        state.dates.to = [dates.to] ?? []
        state.dates.one_way = dates.one_way_by_default
        state.users = list_users || []
        state.terminals.arrivalTerminals = getIncludedTerminals(
          terminals,
          !is_empty_terminals ? default_arrival?.ids : []
        )
        state.countries = getCountriesFromTerminals(terminals)
        state.terminals.departureTerminals = getExcludedTerminals(
          terminals,
          // default_arrival?.ids,
          [],
          !is_empty_terminals ? default_departure?.ids : []
        )

        if (default_departure) {
          state.terminals.defaultDeparture = default_departure
        }

        if (default_arrival && !is_empty_terminals) {
          state.terminals.defaultArrival = default_arrival
        }
      }
    )

    // builder.addMatcher(filtersService.endpoints.getTerminals.matchFulfilled, (state, action) => {
    //   const terminals = action.payload || []
    // })
    builder.addMatcher(filtersService.endpoints.getFlightDates.matchFulfilled, (state, action) => {
      const payload = action.payload
      const { flightFree = [], flightFreeRetur = [] } = payload
      state.dates.availableDepart = flightFree
      state.dates.availableRetur = flightFreeRetur
    })
    builder.addMatcher(
      filtersService.endpoints.getFligthTransportTours.matchFulfilled,
      (state, action) => {
        const { prices = [], airline_codes } = action.payload
        const page = action.meta.arg.originalArgs?.page

        if (!page || page === 1) {
          state.tourse = prices
          state.airline_codes = airline_codes || []
        } else {
          state.tourse = [...state.tourse, ...prices]
        }
      }
    )

    builder.addMatcher(companiesService.endpoints.getCompanies.matchFulfilled, (state, action) => {
      const { companies = [] } = action.payload
      state.companies = companies
    })
  },
})

const selectAviaSearchState = (state) => state.aviaSearch

export const {
  setAviaSearchParams,
  selectAviaTerminalById,
  swapAviaTerminals,
  selectAviaCountryById,
  toggleSelectAllAviaCountries,
  resetAviaCountriesExceptProtected,
  resetAllExceptProtectedTerminals,
  setSelectedAviaTerminals,
} = aviaSearchSlice.actions
export const selectAviaSearchParams = createSelector([selectAviaSearchState], (aviaSearch) => {
  return aviaSearch
})

export const selectAviaSearchDates = createSelector([selectAviaSearchState], (state) => state.dates)

export const selectAviaSearchTerminals = createSelector(
  [selectAviaSearchState],
  (state) => state.terminals
)

export const selectSelectedAviaTerminals = createSelector([selectAviaSearchState], (state) => {
  const { departureTerminals, arrivalTerminals } = state.terminals

  const selectedDeparture = departureTerminals
    ? departureTerminals.flatMap((obj) => obj.terminals.filter((term) => term.is_selected))
    : []

  const selectedArrival = arrivalTerminals
    ? arrivalTerminals.flatMap((obj) => obj.terminals.filter((term) => term.is_selected))
    : []

  return {
    selectedDeparture,
    selectedArrival,
  }
})

export const selectSelectedCountries = createSelector([selectAviaSearchState], (state) => {
  const { departureTerminals } = state.terminals

  const filteredTerminals = departureTerminals.filter((item) => item.is_selected)

  return {
    count: filteredTerminals.length,
    items: filteredTerminals,
  }
})

export const selectSelectedArrivalCountries = createSelector([selectAviaSearchState], (state) => {
  const { arrivalTerminals } = state.terminals

  return arrivalTerminals.filter((item) => item.is_selected)
})

export const selectAviaSearchCurrency = createSelector(
  [selectAviaSearchState],
  (state) => state.currency
)

export const selectAviaSearchResult = createSelector(
  [selectAviaSearchState],
  (state) => state.tourse
)

export const selectAviaSearchPassengers = createSelector(
  [selectAviaSearchState],
  (state) => state.passengers
)

export const selectAviaSearchUsers = createSelector([selectAviaSearchState], (state) => state.users)

export const selectAviaSearchUser = createSelector([selectAviaSearchState], (state) => state.user)

export const selectAviaSearchCountries = createSelector(
  [selectAviaSearchState],
  (state) => state.countries
)

export const selectAviaSearchCompanies = createSelector(
  [selectAviaSearchState],
  (state) => state.companies
)

export const selectAviaSearchAirlinesCodes = createSelector(
  [selectAviaSearchState],
  (state) => state.airline_codes
)

export default aviaSearchSlice.reducer
